export default "__VITE_ASSET__KR4KjwH0__"